module.exports = __webpack_public_path__ + "img/12.61cbd5b5.png";